import { render, staticRenderFns } from "./ShowPixBillModalSection.vue?vue&type=template&id=30fd273b"
import script from "./ShowPixBillModalSection.vue?vue&type=script&lang=js"
export * from "./ShowPixBillModalSection.vue?vue&type=script&lang=js"
import style0 from "./ShowPixBillModalSection.vue?vue&type=style&index=0&id=30fd273b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports